import React, { useState } from 'react';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ChangePassword from './pages/ChangePassword';
import Registration from './pages/Registration';
import Dashboard from './pages/Dashboard';
import DailyList from './pages/DailyList';
import DoctorList from './pages/DoctorList';
import PatientHistory from './pages/PatientHistory';
import Appointments from './pages/Appointments';
import DoctorManagement from './pages/DoctorManagement';
import Reports from './pages/Reports';

export default function App() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('dha_token'));

  const handleLogin = () => setLoggedIn(true);
  const handleLogout = () => {
    localStorage.removeItem('dha_token');
    localStorage.removeItem('dha_role');
    localStorage.removeItem('dha_name');
    setLoggedIn(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          loggedIn ? <Navigate to="/dashboard" replace /> : <Login onLogin={handleLogin} />
        } />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/*" element={
          loggedIn ? (
            <Layout onLogout={handleLogout}>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/register" element={<Registration />} />
                <Route path="/daily-list" element={<DailyList />} />
                <Route path="/patient-history" element={<PatientHistory />} />
                <Route path="/appointments" element={<Appointments />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/doctor-list" element={
                  localStorage.getItem('dha_role') === 'admin'
                    ? <DoctorList />
                    : <Navigate to="/dashboard" replace />
                } />
                <Route path="/doctor-management" element={
                  localStorage.getItem('dha_role') === 'admin'
                    ? <DoctorManagement />
                    : <Navigate to="/dashboard" replace />
                } />
                <Route path="/reports" element={<Reports />} />
              </Routes>
            </Layout>
          ) : (
            <Navigate to="/login" replace />
          )
        } />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}
